// The Steam OpenID form's return_to and realm, shared by LoginPage and RegisterPage.
// `path` is where SteamCallback sends a player who already has an account.

export function getEnvVar() {
  if (import.meta.env.VITE_ENVIRONMENT) return import.meta.env.VITE_ENVIRONMENT;
  return '';
}

export function getSteamRedirectURL(path = '/') {
  const envVar = getEnvVar();
  const safeRedirectURL = encodeURIComponent(path || '/');
  if (envVar === 'development') {
    return `http://localhost:5173/steam/callback?r=${safeRedirectURL.toString()}`;
  }
  return `https://${envVar}play.refrag.gg/steam/callback?r=${safeRedirectURL.toString()}`;
}

// `join` is a creator slug: the backend ties a new Steam sign-up to that creator's LAN party.
export function getSteamAuthURL(path = '/', { join } = {}) {
  const envVar = getEnvVar();
  const base = envVar === 'development' ? 'http://localhost:3000' : `https://${envVar}api.refrag.gg`;
  const joinParam = join ? `&join=${encodeURIComponent(join)}` : '';
  return `${base}/auth/steam/callback?redirect_url=${getSteamRedirectURL(path)}${joinParam}`;
}
